const TABS = {
    onReady() {
        let tabs = document.querySelectorAll('.tabs li');
        tabs.forEach(tab => {
            this.displayTabContent(tab);
        });
    },
    toggle(that) {
        that.parentNode.querySelectorAll('.tabs li').forEach(tab => {
            tab.classList.remove('is-active');
            TABS.displayTabContent(tab);
        });
        that.classList.add('is-active');
        TABS.displayTabContent(that);
    },
    displayTabContent(tab) {
        let tabContent = document.getElementById(tab.dataset.tab);
        if (tabContent === null) return;
        tabContent.classList.add('is-hidden');
        (tab.classList.contains('is-active')) && (tabContent.classList.remove('is-hidden'));
        AOS.init();
    }
}